import { OfferingType } from '../../../../graphql';
import {
  CONVERTIBLE_OFFERING_TYPES,
  FOLLOW_ON_OFFERING_TYPES,
  IPO_OFFERING_TYPES,
  offeringTypeLabels,
} from '../../../../types/domain/offering/constants';

type Props = Readonly<{
  offeringType: OfferingType | null;
}>;

const FO_GROUP_TYPES = FOLLOW_ON_OFFERING_TYPES.filter(t => t !== OfferingType.Rights);

const GROUPS = [IPO_OFFERING_TYPES, FO_GROUP_TYPES, CONVERTIBLE_OFFERING_TYPES];

function getGroupForType(type: OfferingType | null) {
  if (!type) return null;
  return GROUPS.find(group => group.includes(type)) ?? null;
}

export const useGetGroupExcludedTypes = ({ offeringType }: Props) => {
  const selectedGroup = getGroupForType(offeringType);
  if (!selectedGroup) return [];

  const allTypes = (Object.keys(offeringTypeLabels) as OfferingType[]).filter(
    t => t !== OfferingType.RegisteredDirect
  );

  return allTypes.filter(t => !selectedGroup.includes(t));
};
